import { defineVariants } from "@/runtime/style-engine/define-variants";

/**
 * Functional class variants for `<e-qr-code>`.
 *
 * The QR code component is primarily a rendering wrapper so there are
 * very few functional styles — just enough to make it a well‑behaved
 * inline‑block element.
 */
export const qrCodeClasses = defineVariants({
  base: "inline-block",
  variants: {
    type: {
      canvas: "",
      svg: "",
    },
  },
  defaults: {
    type: "canvas",
  },
});
